import { useState, useEffect } from "react";
import { X, BellSimpleRinging, CheckCircle } from "@phosphor-icons/react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const EXCLUDED = ["/basla", "/giris", "/admin", "/panelim", "/basvurum", "/kayit"];
const DISMISSED_KEY = "estem_popup_dismissed";
const SUBSCRIBED_KEY = "estem_subscribed";

export default function SubscriberPopup() {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (EXCLUDED.some(p => pathname.startsWith(p))) return;
    if (localStorage.getItem(SUBSCRIBED_KEY)) return;
    const dismissed = localStorage.getItem(DISMISSED_KEY);
    if (dismissed && Date.now() - Number(dismissed) < 7 * 24 * 60 * 60 * 1000) return;

    let scrollDone = false;
    let timeDone = false;

    const tryShow = () => {
      if (scrollDone || timeDone) setShow(true);
    };

    const onScroll = () => {
      const docH = document.documentElement.scrollHeight - window.innerHeight;
      if (docH > 0 && window.scrollY / docH >= 0.35) {
        scrollDone = true;
        window.removeEventListener("scroll", onScroll);
        tryShow();
      }
    };

    const timer = setTimeout(() => {
      timeDone = true;
      tryShow();
    }, 12000);

    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      clearTimeout(timer);
    };
  }, [pathname]);

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, Date.now().toString());
    setShow(false);
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await api.post("/subscribe", { email, name: null });
      localStorage.setItem(SUBSCRIBED_KEY, "1");
      setDone(true);
      setTimeout(() => setShow(false), 3500);
    } catch {
      setErr("Bir hata oluştu. Lütfen tekrar deneyin.");
    }
    setLoading(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4 bg-black/40 backdrop-blur-sm" data-testid="subscriber-popup">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md relative overflow-hidden animate-in slide-in-from-bottom-4 duration-300">
        {/* Orange accent top */}
        <div className="h-1 bg-gradient-to-r from-brand-primary to-orange-400"/>

        <button
          onClick={dismiss}
          className="absolute top-4 right-4 text-stone-400 hover:text-stone-700 transition-colors w-8 h-8 flex items-center justify-center rounded-full hover:bg-stone-100"
          data-testid="subscriber-popup-close"
        >
          <X weight="bold" size={16}/>
        </button>

        {!done ? (
          <div className="p-8">
            <div className="w-12 h-12 bg-brand-primarySubtle text-brand-primary rounded-xl flex items-center justify-center mb-5">
              <BellSimpleRinging weight="duotone" size={26}/>
            </div>
            <h3 className="font-heading font-bold text-2xl text-brand-ink leading-tight">
              Sınav sistemi güncellendi mi?{" "}
              <span className="font-serif italic font-normal text-brand-primary">İlk bilen siz olun.</span>
            </h3>
            <p className="mt-3 text-sm text-stone-600 leading-relaxed">
              Sınav sistemi değişti mi? Fiyatlar ne olacak? Ehliyet mevzuatında ne var? Her zaman güncel kalın.
            </p>
            <form onSubmit={submit} className="mt-6 space-y-3">
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                placeholder="E-posta adresiniz"
                className="w-full border border-stone-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand-primary/25 focus:border-brand-primary transition-colors bg-stone-50 focus:bg-white"
              />
              <button
                type="submit"
                disabled={loading || !email}
                className="w-full nb-btn !py-3.5 !text-sm disabled:opacity-60"
                data-testid="subscriber-popup-submit"
              >
                {loading ? "Kaydediliyor..." : "Haberdar Ol"}
              </button>
              {err && <p className="text-xs text-red-500 text-center mt-1">{err}</p>}
            </form>
            <p className="mt-3 text-xs text-stone-400 text-center">İstediğiniz zaman aboneliği iptal edebilirsiniz.</p>
          </div>
        ) : (
          <div className="p-10 text-center">
            <div className="w-16 h-16 bg-green-50 text-green-500 rounded-full flex items-center justify-center mx-auto mb-5">
              <CheckCircle weight="duotone" size={36}/>
            </div>
            <h3 className="font-heading font-bold text-xl text-brand-ink">Kaydınız alındı!</h3>
            <p className="mt-2 text-sm text-stone-600">Tüm güncellemelerden haberdar edileceksiniz.</p>
          </div>
        )}
      </div>
    </div>
  );
}
